import { Typography } from 'antd'
import Button from '../../Button'
import React from 'react'
import Flex from '../../Flex'
import { ShortlistDiv, StyledModal, TextDescription } from './style'
import PopPageIcon from '../../icons/PopPageIcon'

const { Text } = Typography

const ActionRoleDrawer = ({
  description,
  textDescription,
  Icon =PopPageIcon,
  showDrawer,
  setShowDrawer,
  onApprove,
  onCloseClick,
  closeText = 'Cancel',
  YesText = 'Yes',
  percentWeight = '90%',
  closeButtonHeight = '40px',
  closeButtonWidth = 'auto',
  yesButtonHeight = '40px',
  yesButtonWidth = 'auto',
}) => {
  const onClose = () => {
    setShowDrawer(false)
    onCloseClick?.()
  }

  const onYesClick = () => {
    onApprove?.()
    setShowDrawer(false)
  }

  return (
    <div>
      <StyledModal
        open={showDrawer}
        centered
        footer={null}
        width={700}
        maskClosable={false}
        closable={false}
      >
        {Icon && <Icon />}

        {description && (
          <ShortlistDiv
            percentHeight={'max-height'}
            percentWeight={percentWeight}
          >
            {description}
          </ShortlistDiv>
        )}

        {/* {textDescription && <TextDescription>{textDescription}</TextDescription>} */}

        <Flex
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '1em',
            padding: '2em',
          }}
        >
          <Button.Secondary
            text={closeText}
            width={closeButtonWidth}
            height={closeButtonHeight}
            onClick={onClose}
          />
          <Button.Primary
            text={YesText}
            width={yesButtonWidth}
            height={yesButtonHeight}
            onClick={onYesClick}
          />
        </Flex>
      </StyledModal>
    </div>
  )
}

export default ActionRoleDrawer
